// extracted by mini-css-extract-plugin
module.exports = {"input":"FormSelect_input__2vSe5","select":"FormSelect_select__2tbor"};